// Shared persistent map theme override used by Live Tracking, Analytics > History
// and Geofencing. The override is tied to the master app theme that was active when
// the user toggled the map: flipping the master Dark/Light switch invalidates it,
// so the master switch always resets the maps until the user toggles a map again.
const KEY = 'ensue_map_theme_override';

export function getMapThemeOverride(isDark) {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    if (!raw || (raw.mode !== 'dark' && raw.mode !== 'light')) return null;
    if (raw.atTheme !== (isDark ? 'dark' : 'light')) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return raw.mode === 'dark';
  } catch {
    return null;
  }
}

export function setMapThemeOverride(darkMap, isDark) {
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ mode: darkMap ? 'dark' : 'light', atTheme: isDark ? 'dark' : 'light' })
    );
  } catch {
    // storage unavailable — the toggle still works for the current page
  }
}
